import React, {FC, useState} from "react";
import {Col, Input, Popover, Row} from "antd";
import Button from "mixins/ui/button/button";
import {AdminContentManagement} from "../admin-content-management.type";
import Props = AdminContentManagement.Props;
import SearchIcon from 'icons/search-icon.svg'
import SearchFilterIcon from 'icons/search-filter-blue.svg'
import FilterForm from "./filter-form";
import {validatePrivileges} from "mixins/helpers";

const AdminContentManagementFilter: FC<Props> = (props: Props) => {
    const { Search } = Input;
    const [searchValue, setSearchValue] = useState<string>();
    const [isMoved, setIsMoved] = useState(false);

    const routeToArchive = () => {
        open(props.siteUrl + props.config.archive_page_url, '_self');
    };

    const routeToCreatePage = () => {
        open(props.siteUrl + props.config.add_page_url, '_self');
    };

    const extendedSearch = (value: any) => {
        props.onSearch(value);
    };

    const clear = () => {
        props.onClear();
    };

    const content = <FilterForm extendedSearch={extendedSearch} search={searchValue} clear={clear} />;

    const onSearch = (value: string) => {
        extendedSearch({ search: value });
    };

    const onSearchChange = (value: any) => {
        setSearchValue(value.target.value);
    };

    const onPopoverOpenChange = (open: boolean) => {
        if (open && !isMoved) {
            setIsMoved(true);

            setTimeout(() => {
                const parent = document.querySelector('.ant-input-group-wrapper');
                const child = document.querySelector('div:has(.ant-popover)');

                parent.appendChild(child);
            }, 0);
        }
    };

    return (
        <div className="admin-content-management__filter">
            <Row gutter={15} justify="space-between">
                <Col span={16}>
                    <Search
                        placeholder="Поиск..."
                        allowClear
                        enterButton="Искать"
                        size="large"
                        prefix={<SearchIcon />}
                        suffix={(
                            <Popover content={content}
                                     trigger="click"
                                     placement="bottom"
                                     arrow={false}
                                     onOpenChange={onPopoverOpenChange}
                            >
                                <a className="d-flex align-items-center gap-2 suffix">
                                    <SearchFilterIcon /> Расширенный поиск
                                </a>
                            </Popover>
                        )}
                        onSearch={onSearch}
                        onChange={onSearchChange}
                    />
                </Col>
                <Col>
                    <Row gutter={15}>
                        <Col>
                            {validatePrivileges(props.roles, props.privileges, 'PRIV_MATERIAL_ADD') && (
                                <Button
                                    className="filter-btn"
                                    type="primary"
                                    color="gold"
                                    uppercase={false}
                                    onClick={routeToCreatePage}
                                >
                                    Добавить материал
                                </Button>
                            )}
                        </Col>
                        <Col>
                            {validatePrivileges(props.roles, props.privileges, 'PRIV_PAGE_ARCHIVE_RESTORE') && (
                                <Button
                                    className="filter-btn"
                                    type="primary"
                                    color="gold"
                                    uppercase={false}
                                    onClick={routeToArchive}
                                >
                                    Корзина
                                </Button>
                            )}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default AdminContentManagementFilter;
